// @flow
/** @jsx h */
import { Component, h } from 'preact'

type HtmlContentProps = {
  content: string,
  type: 'span' | 'p' | 'div',
  className?: string,
  dataKey?: number
}

export class HtmlContent extends Component<HtmlContentProps> {
  shouldComponentUpdate (nextProps: HtmlContentProps) {
    return nextProps.content !== this.props.content
  }

  render () {
    const { content, className, dataKey } = this.props
    switch (this.props.type) {
      case 'p':
        return <p className={className} dangerouslySetInnerHTML={{ __html: content }} data-key={dataKey} />
      case 'div':
        return <div className={className} dangerouslySetInnerHTML={{ __html: content }} data-key={dataKey} />
      default:
        return <span className={className} dangerouslySetInnerHTML={{ __html: content }} data-key={dataKey} />
    }
  }
}
